export enum TimeUnit {
  SECONDS = 1000,
  MINUTES = 60 * TimeUnit.SECONDS,
  HOURS = 60 * TimeUnit.MINUTES,
  DAYS = 24 * TimeUnit.HOURS,
  WEEKS = 7 * TimeUnit.DAYS,
  MONTHS = 30 * TimeUnit.DAYS,
  YEARS = 365 * TimeUnit.DAYS,
}

// TODO: unit test expiryDate function
export function expiryDate(amount: number, unit: TimeUnit): Date {
  const now = new Date();
  const validatedAmount = Math.floor(amount >= 0 ? amount : 0);

  return new Date(now.getTime() + validatedAmount * unit);
}

export function expiryDateFromMinutes(minutes: number): Date {
  return expiryDate(minutes, TimeUnit.MINUTES);
}
